import { useContext } from "react"
import { PageConfigContext } from "~/contexts/page-title"

export default function usePageConfigContext() {
  const context = useContext(PageConfigContext)
  return context
}
